export default __webpack_public_path__ + "static/media/posts.206fbd18.png";